import { jsx as e } from "react/jsx-runtime";
import { d as m, w as f, x as c } from "../../../vendor-Dd6qj6gJ.js";
import { layer as n } from "../../../theme/layer.js";
import "react";
import { getSpacingClasses as b } from "../../../utils/getSpacingClasses/index.js";
import { omitStyleRenderProps as v } from "../../../utils/omitStyleRenderProps/index.js";
import { s } from "../../../shared.module-D29A9dsV.js";
import '../../../assets/index22.css';const x = "_popover_3rdjd_1", $ = {
  popover: x
}, j = ({ children: r, p: a, pb: t, pl: p, pr: l, pt: d, ...o }) => {
  const i = m($.popover, s.surface, b({ p: a, pb: t, pl: p, pr: l, pt: d }));
  return /* @__PURE__ */ e(
    f,
    {
      ...v(o),
      isKeyboardDismissDisabled: !1,
      isNonModal: !1,
      shouldCloseOnInteractOutside: () => !0,
      className: i,
      style: { zIndex: n("popover") },
      "data-component": "Popover",
      children: /* @__PURE__ */ e(c, { className: s.dialog, "aria-label": o["aria-label"], children: r })
    }
  );
};
export {
  j as Popover
};
